import type { ReactNode } from 'react';

import { cx } from '@/shared/lib/cx';

import styles from './chip.module.scss';

export type ChipTone = 'neutral' | 'body' | 'care' | 'mind';

export type ChipProps = {
  children: ReactNode;
  tone?: ChipTone;
  /** "filled" — 01B soft chip; "text" — catalog uppercase label; "outlined" — bordered pill. */
  appearance?: 'filled' | 'text' | 'outlined';
  className?: string | undefined;
};

export function Chip({ children, tone = 'neutral', appearance = 'filled', className }: ChipProps) {
  return (
    <span className={cx(styles.root, className)} data-tone={tone} data-appearance={appearance}>
      {children}
    </span>
  );
}
